import { createFeatureSelector, createSelector } from '@ngrx/store';
import { normaliseVirtualsVerdict } from './user-details.reducer';
import {
  IAccountVirtualsVerdict,
  IUserDetailsState,
  IVirtualsVerdict,
} from './user-details.state';

export const selectUserDetailsState =
  createFeatureSelector<IUserDetailsState>('userDetails');

export const selectUserDetailsData = createSelector(
  selectUserDetailsState,
  (state) => state
);

const selectUserFbId = createSelector(
  selectUserDetailsState,
  (state): string => (state && typeof state.fbId === 'string' ? state.fbId : '')
);

const selectStoredVirtualsVerdict = createSelector(
  selectUserDetailsState,
  (state): IVirtualsVerdict | undefined => (state ? state.virtuals : undefined)
);

/**
 * The server's virtuals verdict together with the account it belongs to.
 *
 * Built from two memoised inputs on purpose: a balance write (setBalances,
 * the Supabase feed — several per minute during play) keeps both the fbId
 * and the verdict object by reference, so this selector does NOT re-emit for
 * it. Only a new account payload or a clear does. The stored verdict goes
 * through the reducer's own normaliseVirtualsVerdict once more — one rule,
 * not a copy of it — so a state that somehow skipped the reducer (a test
 * store, a future action) still fails closed.
 */
export const selectVirtualsVerdict = createSelector(
  selectUserFbId,
  selectStoredVirtualsVerdict,
  (fbId, verdict): IAccountVirtualsVerdict => ({
    fbId,
    ...normaliseVirtualsVerdict(verdict),
  })
);
